import React, { useEffect } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

export function Modal({ isOpen, onClose, children, title }: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEscape);
    }

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? "modal-title" : undefined}
    >
      <div
        className="relative w-full max-w-lg rounded-lg shadow-2xl max-h-[90vh] overflow-y-auto"
        style={{
          background: "#4a5568",
          padding: "20px",
          border: "6px solid #395839",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            background: "#ffffff",
            borderRadius: "6px",
            overflow: "visible",
            padding: "10px",
          }}
        >
          {title && (
            <div
              className="flex items-center justify-center px-6 py-4"
              style={{
                background: "#395839",
                position: "relative",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderBottomRightRadius: "6px",
              }}
            >
              <h2
                id="modal-title"
                className="text-xl font-bold text-white text-center"
                style={{ paddingRight: "3rem", paddingLeft: "3rem" }}
              >
                {title}
              </h2>
              <button
                onClick={onClose}
                className="text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white rounded transition-colors"
                aria-label="Close modal"
                style={{
                  position: "absolute",
                  right: "1.5rem",
                }}
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
          )}
          <div className="px-6 py-5">{children}</div>
        </div>
      </div>
    </div>
  );
}
